import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import SprzedazMiesiecznychSearchbox from "./components/SprzedazMiesiecznychLiniaSearchbox";
import RaportyService from "../RaportyService";
import initialData from "../../../utilities/initialData/initialData";
import LiniowyMiesiecznyChart from "./components/LiniowyMiesiecznyChart";
import DlaJednejLiniMiesiecznyChart from "./components/DlaJednejLiniMiesiecznyChart";

export default class SprzedazMiesiecznychLiniaContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            params: null,
            daneLiniowyZnizki: [],
            daneLiniowyGeneral: [],
            daneDlaLiniiZnizki: [],
            daneDlaLiniiGeneral: [],
            daneDlaLiniiSzczegoly: [],
        };
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }

    componentDidMount() {
        let params = {
            "idLi": null,
            "nazLi": null,
            "mies": parseInt(new Date().toJSON().substr(5, 2)),
            "miesNazwa": initialData.returnArrayMiesiace().find(m => m.value == parseInt(new Date().toJSON().substr(5, 2))).label,
            "rok": new Date().toJSON().substr(0, 4),
            "statBil":null,
            "statusNazwa": null,
        }
        this.onClickSzukaj(params)
    }

    onClickSzukaj(params) {
        RaportyService.pobierzRaportBiletowMiesiecznychLinie(params).then(function (response) {
            this.setState({params: params})

            if (Boolean(params.idLi)) {
                // dla jednej linii
                this.setState({
                    daneDlaLiniiZnizki: response.data[0],
                    daneDlaLiniiGeneral: response.data[1],
                    daneDlaLiniiSzczegoly: response.data[2],
                })
            }
            else {
                // liniowy
                this.setState({
                    daneLiniowyZnizki: response.data[0],
                    daneLiniowyGeneral: response.data[1],
                })
            }
        }.bind(this))
    }

    renderNaglowek(params) {

        let naglowek = 'Sprzedaż dla wszystkich linii'
        if (Boolean(params.idLi)) {
            naglowek = 'Sprzedaż dla linii ' + params.nazLi
        }

        if (params.dataOd == params.dataDo) {
            naglowek = naglowek + ' w miesiącu ' + params.miesNazwa + ' ' + params.rok
        }

        if (Boolean(params.statusNazwa)) {
            naglowek = naglowek + ' ze statusem ' + params.statusNazwa
        }

        return naglowek
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'RaportyContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb
                                    links={[{addressUrl: '/raporty', text: 'Raporty'}, {
                                        addressUrl: '/raporty/sprzedaz-mies-linie',
                                        text: 'Sprzedaż biletów miesięcznych per linia'
                                    }]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <SprzedazMiesiecznychSearchbox handleClickSzukaj={this.onClickSzukaj}/>
                        </Col>
                        <Col xs={12}>
                            {
                                Boolean(this.state.params) ?
                                    Boolean(this.state.params.idLi) ?
                                        <div>
                                            <Col xs={12}>
                                                <h2 style={{textAlign: 'center'}}>{this.renderNaglowek(this.state.params)}</h2>
                                            </Col>
                                            <DlaJednejLiniMiesiecznyChart
                                                daneDlaLiniiZnizki={this.state.daneDlaLiniiZnizki}
                                                daneDlaLiniiGeneral={this.state.daneDlaLiniiGeneral}
                                                daneDlaLiniiSzczegoly={this.state.daneDlaLiniiSzczegoly}
                                                colorArray={initialData.returnColorArray()}
                                            />
                                        </div>
                                        :
                                        <div>
                                            <Col xs={12}>
                                                <h2 style={{textAlign: 'center'}}>{this.renderNaglowek(this.state.params)}</h2>
                                            </Col>
                                            <LiniowyMiesiecznyChart
                                                daneLiniowyZnizki={this.state.daneLiniowyZnizki}
                                                daneLiniowyGeneral={this.state.daneLiniowyGeneral}
                                                daneDlaLiniiSzczegoly={this.state.daneDlaLiniiSzczegoly}
                                                colorArray={initialData.returnColorArray()}
                                            />
                                        </div>
                                    :
                                    ''
                            }
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/SprzedazMiesiecznychLinia/SprzedazMiesiecznychLiniaContainer.js